import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();

export class ZIDXAccountSiteEdit implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountSiteEditContainer";
    }

    websiteTypeChange(){
        let page=".zidxAccountSiteEditContainer.zidxPageActive";
        let root=this.zidx.peakidxShadowRoot;
        let type=$(page+" input[name='idx_site_type']:checked", root).val();
        let isWordpress=(type=="wordpress" || type=="wpiframe");
        let isCDN=(type=="cdn");
        const isHubSpot = type === "hubspot-app";
        for (const name of ["hubspot_slug", "idx_site_hubspot_portal_id", "idx_site_hubspot_parent_origins"]) {
            $(page+" #"+name+"_container", root).toggle(isHubSpot);
        }
        $(page+" #wordpress_domain_container", root).toggle(isWordpress);
        $(page+" #wordpress_slug_container", root).toggle(isWordpress);
        $(page+" #cdn_domain_container", root).toggle(isCDN);
        $(page+" #cdn_slug_container", root).toggle(isCDN);
        if(isWordpress){
            if($(page+" #wordpress_slug", root).val()=="/"){
                $(page+" #wordpress_slug", root).val("/real-estate/");
            }
        }else if(isCDN){
            if($(page+" #cdn_slug", root).val()=="/"){
                $(page+" #cdn_slug", root).val("/real-estate/");
            }
        }else{
            $(page+" #wordpress_slug", root).val("/");
        }
    }

    render() {
        // console.log("site edit");
        let self=this;

        $(".zidxAccountSiteEditContainer.zidxPageActive input[name='idx_site_type']", this.zidx.peakidxShadowRoot).on("change", function(e){
            e.preventDefault();
            self.websiteTypeChange();
        });
        this.websiteTypeChange();

        $(".zidxPageActive input[name=idx_site_name]", this.zidx.peakidxShadowRoot).on("input", function(this:HTMLInputElement){
            let siteName=this.value;
            $(".zidxSiteDomainSpan", self.zidx.peakidxShadowRoot).text("https://"+siteName+".peakidxsites.com");
        }).each(function(this){
            let siteName=(this as HTMLInputElement).value;
            $(".zidxSiteDomainSpan", self.zidx.peakidxShadowRoot).text("https://"+siteName+".peakidxsites.com");
        });

    }
}
